import Navbar from "@/components/Navbar";
import { Link } from "react-router-dom";
import { currentTheme } from "@/lib/theme";
import { useCmsContent } from "@/lib/cms";
import { BACKEND_URL } from "@/lib/api";

function resolveImage(img) {
  if (!img || typeof img !== "object") return "/logo.png";
  const url = img.url || "/logo.png";
  if (url.startsWith("http") || url.startsWith("/")) return url;
  // Storage paths returned from CMS uploads start with "bagdashkids/..."
  return `${BACKEND_URL}/api/cms/files/${url}`;
}

export default function Layout({ children }) {
  const theme = currentTheme();
  const { c } = useCmsContent("global");
  const logoSrc = resolveImage(c["global.logo.url"]);
  const logoAlt = (c["global.logo.url"] && c["global.logo.url"].alt) || "Bag Dash Kids";
  const brand = c["global.brand_name"] || "Bag Dash Kids";
  const tagline = c["global.footer.tagline"] || "";
  const exploreTitle = c["global.footer.col_explore_title"] || "Explore";
  const explore = c["global.footer.col_explore"] || [];
  const helpTitle = c["global.footer.col_help_title"] || "Help";
  const help = c["global.footer.col_help"] || [];
  const copySuffix = c["global.footer.copyright_suffix"] || "";

  return (
    <div className={`min-h-screen flex flex-col bg-gradient-to-b ${theme.accent}`} data-theme={theme.label}>
      <Navbar />
      <main className="flex-1">{children}</main>
      <footer className="border-t-2 border-slate-100 bg-white py-8 mt-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 grid sm:grid-cols-3 gap-6">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <img src={logoSrc} alt={logoAlt} className="h-10 w-10 rounded-xl object-contain bg-green-600 p-0.5"/>
              <span className="font-fredoka font-bold text-slate-900">{brand}</span>
            </div>
            <p className="text-xs text-slate-500">{tagline}</p>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">{exploreTitle}</div>
            <ul className="text-sm text-slate-700 space-y-1">
              {explore.map((l, i) => (
                <li key={i}><Link to={(l.bullets && l.bullets[0]) || "/"} className="hover:text-green-700">{l.title}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">{helpTitle}</div>
            <ul className="text-sm text-slate-700 space-y-1">
              {help.map((l, i) => (
                <li key={i}><Link to={(l.bullets && l.bullets[0]) || "/"} className="hover:text-green-700">{l.title}</Link></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-100 mt-6 pt-4 max-w-6xl mx-auto px-4 sm:px-6 text-xs text-slate-400 text-center">
          © {new Date().getFullYear()} {brand} · {copySuffix}
        </div>
      </footer>
    </div>
  );
}
